import React, { useState } from "react"

import "./ExpenseForm.css"

function ExpenseForm(props) {
	const [enteredTitle, setEnteredTitle] = useState("")
	const [enteredAmount, setEnteredAmount] = useState("")
	const [enteredDate, setEnteredDate] = useState("")

	const titleChangeHandler = (e) => {
		setEnteredTitle(e.target.value)
	}

	const amountChangeHandler = (e) => {
		setEnteredAmount(e.target.value)
	}

	const dateCHangeHandler = (e) => {
		setEnteredDate(e.target.value)
	}

	const submitHandler = (e) => {
		e.preventDefault()
		const expenseData = {
			title: enteredTitle,
			amount: +enteredAmount,
			date: new Date(enteredDate),
		}

		props.onSaveExpenseData(expenseData)

		setEnteredTitle("")
		setEnteredAmount("")
		setEnteredDate("")
	}

	return (
		<form onSubmit={submitHandler}>
			<div className='new-expense__controls'>
				<div className='new-expense__control'>
					<label>Title</label>
					<input
						type='text'
						value={enteredTitle}
						onChange={titleChangeHandler}
					/>
				</div>
			</div>
			<div className='new-expense__controls'>
				<div className='new-expense__control'>
					<label>Amount</label>
					<input
						type='number'
						min='0.01'
						step='0.01'
						value={enteredAmount}
						onChange={amountChangeHandler}
					/>
				</div>
			</div>
			<div className='new-expense__controls'>
				<div className='new-expense__control'>
					<label>Date</label>
					<input
						type='date'
						min='2021-01-01'
						max='2023-12-31'
						value={enteredDate}
						onChange={dateCHangeHandler}
					/>
				</div>
			</div>
			<div className='new-expense__actions'>
				<button type='button' onClick={props.triggerForm}>
					Cancel
				</button>
				<button type='submit'>Add Expense</button>
			</div>
		</form>
	)
}

export default ExpenseForm
